import React, {useEffect, useState} from "react";
import {withRouter} from 'react-router-dom'
import styles from "./style.module.scss";
import {BottomNavigation, BottomNavigationAction} from "@material-ui/core";
import ColorIcons from "components/ColorIcons";

export default withRouter(({location, history}) => {
    const [path, setPath] = useState('0');

    useEffect(()=>{
        setPath(location.pathname.split('/')[2]);
    }, [location]);

    return <BottomNavigation
        value={path}
        onChange={(event, newValue) => {
            history.push('/illegal/' + newValue);
        }}
        className={styles.bottomNav}
        showLabels>
        <BottomNavigationAction
            value={'carcheck'}
            label={<div className={styles.label}>차량조회</div>}
            icon={<ColorIcons name={'title-carcheck'} size={19}/>}
        />
        <BottomNavigationAction
            value={'report'}
            label={<div className={styles.label}>신고내역</div>}
            icon={<ColorIcons name={'title-carcheck'} size={19}/>}
        />
        <BottomNavigationAction
            value={'setting'}
            label={<div className={styles.label}>설정</div>}
            icon={<ColorIcons name={'title-setting'} size={19}/>}
        />
    </BottomNavigation>
});
